import React from 'react';
import {Scrollbars} from 'react-custom-scrollbars';

export default class ColoredScrollbars extends React.PureComponent {

    constructor(props, ...rest) {
        super(props, ...rest);
        this.state = {top: 0};
        this.handleUpdate = this.handleUpdate.bind(this);
        this.renderView = this.renderView.bind(this);
        this.renderTrackVertical = this.renderTrackVertical.bind(this);
        this.renderThumb = this.renderThumb.bind(this);
    }

    handleUpdate(values) {
        const {top} = values;
        this.setState({top});
    }


    renderView({style, ...props}) {
        const viewStyle = {
            padding: 15,
            paddingRight: 24,
        };
        return (
            <div
                className="box"
                style={{...style, ...viewStyle}}
                {...props}
            />
        );
    }

    renderTrackVertical({style, ...props}) {
        const trackStyle = {
            position: 'absolute',
            width: '8px',
            right: '6px',
            top: '8px',
            bottom: '8px',
            borderRadius: '999px',
            background: 'rgba(8, 12, 18, 0.34)',
            boxShadow: 'inset 0 0 0 1px rgba(214, 227, 240, 0.08)',
            zIndex: 24,
        };

        return (
            <div
                style={{...style, ...trackStyle}}
                {...props}
            />
        );
    }

    renderThumb({style, ...props}) {
        const thumbStyle = {
            background: `linear-gradient(180deg, rgba(0, 206, 201, 0.94), rgba(253, 121, 168, 0.86))`,
            borderRadius: '999px',
            boxShadow: `0 0 8px rgba(0, 206, 201, 0.24), 0 0 14px rgba(253, 121, 168, 0.16), inset 0 0 0 1px rgba(255, 255, 255, 0.18)`,
            zIndex: 25,
        };
        return (
            <div
                style={{...style, ...thumbStyle}}
                {...props}
            />
        );
    }

    render() {
        return (
            <Scrollbars
                autoHide
                // Hide delay in ms
                autoHideTimeout={1000}
                // Duration for hide animation in ms.
                autoHideDuration={200}
                renderView={this.renderView}
                renderTrackVertical={this.renderTrackVertical}
                renderThumbVertical={this.renderThumb}
                onUpdate={this.handleUpdate}
                {...this.props}
            />
        );
    }
}
